import { FormGroup } from '@angular/forms';
import { getControl, getGroup } from '@shared/helpers/form.helper';
import { formPaths } from '@shared/constants/form-paths.const';

export const getCoopAltreCoopGroup = (form: FormGroup): FormGroup => getGroup(form, formPaths.schedaAltreCoop);

export const getCoopAltreCoopControl = (form: FormGroup, path: string) => getControl(form, `${formPaths.schedaAltreCoop}.${path}`);
